export enum SurveyEnum {
    PUBLIC_CUSTOMER_PROJECT_SATISFACTION = 'public.customer_project_satisfaction',
    PUBLIC_CUSTOMER_PROJECT_SATISFACTION_V2 = 'public.customer_project_satisfaction_v2',
    PUBLIC_USER_PROJECT_SATISFACTION_V1 = 'public.user_project_satisfaction_v1',
}
